import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentTrackingComponent } from './shipment-tracking.component';
import {TimelineModule} from 'primeng/timeline';
import {CardModule} from 'primeng/card';
import {ToastModule} from 'primeng/toast';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import { TrackingStandaloneVerticalComponent } from './tracking-standalone-vertical/tracking-standalone-vertical.component';
import {RippleModule} from "primeng/ripple";




@NgModule({
    declarations: [ShipmentTrackingComponent, TrackingStandaloneVerticalComponent],
    exports: [
        ShipmentTrackingComponent,
        TrackingStandaloneVerticalComponent
    ],
    imports: [
        ButtonModule,
        CommonModule,
        TimelineModule,
        CardModule,
        ToastModule,
        InputTextModule,
        FormsModule,
        RippleModule
    ]
})
export class ShipmentTrackingModule { }
